import React from "react";
import { BrainIcon, CalendarCheckIcon, FileTextIcon, ListChecksIcon, BoxIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { tools } from "../../data/content";
const iconMap: Record<string, BoxIcon> = {
  planner: CalendarCheckIcon,
  matrix: BoxIcon,
  worksheet: FileTextIcon,
  brain: BrainIcon,
  checklist: ListChecksIcon
};
export function Tools() {
  return <section aria-labelledby="tools" className="bg-white px-4 py-16 sm:py-24" data-id="element-320" data-mp="28ko2qcoy865c">
      <div className="mx-auto max-w-4xl" data-id="element-321" data-mp="23ruz5s57v3uu">
        <div id="tools" data-id="element-322" data-mp="23qtlrh0qa59y">
          <SectionHeading kicker="Plus" title="Practical educational tools to support your study" subtitle="Your collection also includes resources designed to help you organize what you’re learning." data-id="element-323" data-mp="1yt0jv06gjxfh" />
        </div>

        <ul className="mt-12 divide-y divide-ink/10 rounded-3xl bg-paper px-5 sm:px-8" data-id="element-324" data-mp="1prtxiah4nseb">
          {tools.map(t => {
          const Icon = iconMap[t.icon];
          return <li key={t.title} className="flex gap-4 py-6" data-id="element-325" data-mp="159g79q84j9jr">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-navy-900 text-aqua" data-id="element-326" data-mp="15852po6utxrl">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-327" data-mp="1a20ycjznb8jl" />
                </span>
                <div data-id="element-328" data-mp="w6orje87trmb">
                  <h3 className="font-display text-lg font-extrabold leading-snug text-ink sm:text-xl" data-id="element-329" data-mp="10ad0o1chwv9o">{t.title}</h3>
                  <p className="mt-1.5 leading-relaxed text-ink/70" data-id="element-330" data-mp="1nzfs20wxm2hd">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-lg leading-relaxed text-ink/75" data-id="element-331" data-mp="1syim6qbdioak">
          Everything is designed to complement the six volumes and help you navigate your educational resources without
          constantly jumping between disconnected documents.
        </p>

        <SectionCta label="I want access to the complete ABG learning system" data-id="element-332" data-mp="3jb3k5mhw6ec" />
      </div>
    </section>;
}